import * as type from '../constants/b2b';
import {message} from 'antd';
const initialState = {
  accessToken: null,
  isGranted: false
}
export default (state = initialState, action={}) => {
	switch (action.type) {
		case type.MESSAGE_REQUEST:
			return Object.assign(
				{},
				state
			);
		case type.MESSAGE_SUCCESS:
			return Object.assign({},
				state,
				{
					isAuthenticated: true,
					token: action.response.data.token
				}
			);
		case type.MESSAGE_FAILED:
			return Object.assign({},
				state,
				{}
			);
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/b2b.js